/**
 * @fileoverview Connect failed React rendering to a recoverable application surface and bounded diagnostic reporting. `browserErrorReporting.js` owns report projection/delivery; this boundary owns fallback display. Recovery reloads the browser context rather than repairing backend business state or replaying a failed mutation.
 */
import React from 'react';
import { reportBrowserError } from './browserErrorReporting';

 
export default class BrowserErrorBoundary extends React.Component {
  state = { failed: false };

   
  static getDerivedStateFromError() {
    return { failed: true };
  }

   
  componentDidCatch(error) {
    reportBrowserError('render', error);
  }

   
  render() {
    if (this.state.failed) {
      return <main role="alert"><p>The page could not be displayed.</p>
        <button type="button" onClick={() => window.location.reload()}>Reload page</button></main>;
    }
    return this.props.children;
  }
}
